export const statusOptions = [
	{ key: 'WaitlistCount', label: 'Waitlist', labelShort: 'Waitlist' },
	{ key: 'CertifiedCount', label: 'Funnel Certification', labelShort: 'Certified' },
    { key: 'FunnelAccessCount', label: 'Funnel Access', labelShort: 'Access' },
    { key: 'SubscriptionCount', label: 'Subscriptions', labelShort: 'Subscriptions' },
    //{ key: 'MonthlySubscriptionTotal', label: 'Monthly Revenue', labelShort: 'Revenue' }
]
